import { Theme } from '@yandex-int/k-common/typings';

export const doesThemeExist = (themeId: number, themes: Array<Theme>) =>
    themes && themes.some(({ id }) => id === themeId);
